export default {
  list: { lazy: () => import('./ProposalViewersList') },
  options: {
    list: {
      title: 'Customer ProposalViewers',
      subtitle:
        'Enable, Disable or Delete customers who have access to the online proposal through the shareable link.',
      breadCrumb: 'Proposal Viewers',
    },
  },
}
